import { setSelectedEstimateIds } from '../../../State/selectedEstimateIds'

export default (ids) => (dispatch) => {

  dispatch(setSelectedEstimateIds(ids))

}
